export const initialState = ({
  defaultTab,
  visibleTabs,
  showQrCode,
}) => ({
  defaultTab,
  visibleTabs,
  showQrCode,
});

export const types = {
  SET_DEFAULT_TAB: 'SET_DEFAULT_TAB',
  SET_VISIBLE_TABS: 'SET_VISIBLE_TABS',
  SET_MULTI: 'SET_MULTI',
  SET_SHOW_QR_CODE: 'SET_SHOW_QR_CODE',
};

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case types.SET_DEFAULT_TAB:
      return { ...state, defaultTab: payload };
    case types.SET_VISIBLE_TABS:
      return { ...state, visibleTabs: payload };
    case types.SET_SHOW_QR_CODE:
      return { ...state, showQrCode: !state.showQrCode };
    case types.SET_MULTI:
      return { ...state, ...payload };
    default:
      throw new Error();
  }
};
